import React from 'react';

export interface RateAnswerSummaryProps {
  title: string;
  description: string;
  width?: number;
  height?: number;
  iconBackgroundColor?: string;
  positions?: {
    line?: { left: number; top: number };
    title?: { left: number; top: number };
    description?: { left: number; top: number; width: number };
    icon?: { left: number; top: number };
  };
}

const RateAnswerSummary: React.FC<RateAnswerSummaryProps> = ({
  title,
  description,
}) => {
  return (
    <div className="relative py-7">
      <div className="flex gap-2 items-center pb-4">
        <div className="flex h-9 w-9 items-center justify-center gap-2.5 rounded-[10px] bg-[#0064ff] p-1">
          <svg
            width={22}
            height={18}
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-[17.93px] w-[21.5px] flex-shrink-0 flex-grow-0"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.51367 2.40311C8.51367 1.09894 9.57757 0.0351562 10.8819 0.0351562H19.3818C20.6861 0.0351562 21.75 1.09894 21.75 2.40311V8.0778C21.75 9.38214 20.686 10.4455 19.3818 10.4455H19.3423L19.3419 13.0842C19.3418 13.3977 19.1468 13.678 18.8529 13.7872C18.5591 13.8963 18.2284 13.8111 18.0237 13.5737L15.3279 10.4455H14.0241V8.94546H15.6717C15.8899 8.94546 16.0974 9.04053 16.2398 9.20586L17.8422 11.0653L17.8424 9.69534C17.8425 9.28117 18.1783 8.94546 18.5924 8.94546H19.3818C19.858 8.94546 20.25 8.55323 20.25 8.0778V2.40311C20.25 1.9275 19.8578 1.53516 19.3818 1.53516H10.8819C10.4059 1.53516 10.0137 1.9275 10.0137 2.40311V3.65974H8.51367V2.40311Z"
              fill="#E1EAF7"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.6186 5.66797C2.14334 5.66797 1.75098 6.06014 1.75098 6.53592V12.2098C1.75098 12.6859 2.14343 13.078 2.6186 13.078H3.40858C3.82275 13.078 4.15851 13.4137 4.15858 13.8279L4.15881 15.1976L5.76088 13.3384C5.90335 13.1731 6.11079 13.078 6.32904 13.078H11.1189C11.5948 13.078 11.9871 12.6857 11.9871 12.2098V6.53592C11.9871 6.06032 11.5949 5.66797 11.1189 5.66797H2.6186ZM0.250977 6.53592C0.250977 5.23192 1.31471 4.16797 2.6186 4.16797H11.1189C12.4232 4.16797 13.4871 5.23175 13.4871 6.53592V12.2098C13.4871 13.5141 12.4232 14.578 11.1189 14.578H6.67281L3.97732 17.7062C3.77269 17.9436 3.44196 18.0288 3.14808 17.9197C2.85421 17.8106 2.65921 17.5302 2.65915 17.2167L2.65871 14.578H2.6186C1.31462 14.578 0.250977 13.514 0.250977 12.2098V6.53592Z"
              fill="#E1EAF7"
            />
          </svg>
        </div>

        <h4 className="text-left text-lg font-bold text-[#20262a]">{title}</h4>
      </div>

      <p className="text-left text-[15px] text-[#20262a] break-words">{description}</p>
    </div>
  );
};

export default RateAnswerSummary;
